const autopromoButtonCopy = 'Sprawdź teraz';

const slideCommon = {
  containerAlign: 'left',
  isCenterAlign: false,
  darkFontVersion: false,
  imgUrl: [
    {
      imgs: [
        {
          url: 'mobile1x',
          density: 1
        },
        {
          url: 'mobile2x',
          density: 2
        },
        {
          url: 'mobile3x',
          density: 3
        }
      ],
      width: 360
    },
    {
      imgs: [
        {
          url: 'desktop1x',
          density: 1
        },
        {
          url: 'desktop2x',
          density: 2
        }
      ],
      width: 600
    }
  ],
  altText: 'Profil Pracuj.pl',
  title: 'Pracuj, skąd lubisz!',
  subtitle: 'Oferty pracy zdalnej',
  buttons: [
    {
      img: [],
      altText: autopromoButtonCopy,
      text: autopromoButtonCopy,
      lightBgColor: true,
      url: 'https://www.pracuj.pl/praca?rw=true&utm_source=autopromo&utm_medium=box&utm_campaign=kamp_sty_21',
      linkTitle: autopromoButtonCopy
    }
  ]
};

const slideDesktop = {
  isCenterAlignDesktop: false,
  title: 'Pracuj, skąd lubisz!',
  subtitle: 'Oferty pracy zdalnej',
  buttons: [
    {
      img: [],
      altText: autopromoButtonCopy,
      text: autopromoButtonCopy,
      lightBgColor: true,
      url: 'https://www.pracuj.pl/praca?rw=true&utm_source=autopromo&utm_medium=box&utm_campaign=kamp_sty_21',
      linkTitle: autopromoButtonCopy
    }
  ]
};

export default { ...slideCommon, slideDesktop };
